module.exports = __webpack_public_path__ + "static/media/pottery-barn-small_2x.5e822b79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/pottery-barn-small_2x.png
// module id = 698
// module chunks = 27